export const GUARDIANSHIP_START_ROUTES_SEGMENTS = {
  courtOrder: 'court-order',
  outOfJurisdiction: 'out-of-jurisdiction',
  account: 'account',
  confirmation: 'confirmation',
  withoutCourtOrder: 'without-court-order',
  invitation: 'invitation',
} as const;
